import React, {useEffect, useState} from 'react';
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import './style.scss'
import InputAdornment from "@material-ui/core/InputAdornment";
import Input from "@material-ui/core/Input";


export default function CreditDialog(props) {
    const [creditAmount, setCreditAmount] = useState(0);

    useEffect(() => {
        if (props.maxCreditAmount && props.isOpen)
            setCreditAmount(props.maxCreditAmount);

    }, [props.maxCreditAmount, props.isOpen]);

    function onClose() {
        if (props.onCloseRequest)
            props.onCloseRequest();
    }

    function onCredit() {
        if (creditAmount <= 0 || creditAmount > props.maxCreditAmount)
            return;

        if (props.onCreditRequest)
            props.onCreditRequest(creditAmount);
    }

    function onCreditAmountChange(event) {
        if (event.target.value === "")
            setCreditAmount(0);
        else
            setCreditAmount(parseInt(event.target.value));
    }

    return (
        <Dialog className="credit-dialog" open={props.isOpen} onClose={onClose}>
            <DialogTitle>זיכוי</DialogTitle>
            <DialogContent className="dialog-content">
                זכה את השליח ב
                <Input
                    autoFocus
                    className="credit-amount-input"
                    value={creditAmount}
                    onChange={onCreditAmountChange}
                    startAdornment={<InputAdornment className="input-adornment" position="start">₪</InputAdornment>}
                    error={creditAmount <= 0 || creditAmount > props.maxCreditAmount}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter')
                            onCredit();
                    }}
                />
            </DialogContent>
            <DialogActions className="dialog-actions">
                <IconButton className="close-button"
                            onClick={onClose}>
                    <CloseIcon fontSize="small"/>
                </IconButton>
                <Button variant="contained" color="primary" onClick={onCredit} disabled={creditAmount <= 0 || creditAmount > props.maxCreditAmount}>
                    זכה
                </Button>
            </DialogActions>
        </Dialog>
    );
}